import { ACTIONS } from "../constants"


const initialState = { 
  accessReports : [],
  accessReport : [],
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: {
    isDeactivated: false,
    isActivated: false,
    isCreated: false,
    isUpdated: false,
    isDeleted :false,
  },
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_ACCESS_REPORT: {
      return { ...state, success: initialState.success, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_ACCESS_REPORTS_INIT : {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_ACCESS_REPORTS_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, accessReports: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_ACCESS_REPORTS_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_ACCESS_REPORT_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.CREATE_ACCESS_REPORT_SUCCEDED : {
      return { ...state, success: { ...state.success, isCreated: true }, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_ACCESS_REPORT_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }


    case ACTIONS.DEACTIVATE_ACCESS_REPORT_INIT : {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DEACTIVATE_ACCESS_REPORT_SUCCEDED : {
      return { ...state, success: { ...state.success, isDeactivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.DEACTIVATE_ACCESS_REPORT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }



    case ACTIONS.ACTIVATE_ACCESS_REPORT_INIT : { 
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.ACTIVATE_ACCESS_REPORT_SUCCEDED : {
      return { ...state, success: { ...state.success, isActivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.ACTIVATE_ACCESS_REPORT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }


    case ACTIONS.EDIT_ACCESS_REPORT_INIT: {      
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.EDIT_ACCESS_REPORT_SUCCEDED : {
      return { ...state, success: { ...state.success, isUpdated: true }, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_ACCESS_REPORT_FAILED: {
      return { ...state, error: payload, isLoading: false }
    }


 
    case ACTIONS.FETCH_ACCESS_REPORT_INIT : {
      return { ...state, isLoading: true, success: initialState.success, accessReport: null, error: null }
    }
    case ACTIONS.FETCH_ACCESS_REPORT_SUCCEDED : {
      return { ...state, accessReport: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_ACCESS_REPORT_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }



    case ACTIONS.DELETE_ACCESS_REPORT_INIT : {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DELETE_ACCESS_REPORT_SUCCEDED: {
      return { ...state, success: { ...state.success, isDeleted: true }, isLoading: false, error: null }
    }
    case ACTIONS.DELETE_ACCESS_REPORT_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }
    default: {
      return state
    }

    case ACTIONS.ACCESS_REPORT_RESULTS_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.ACCESS_REPORT_RESULTS_SUCCEDED : {
      return { ...state, success: { ...state.success, isCreated: true }, accessReport: payload, isLoading: false, error: null }
    }
    case ACTIONS.ACCESS_REPORT_RESULTS_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }

  }
}
